import { render } from "./Ntfy.vue?vue&type=template&id=1c4a4708"
import script from "./Ntfy.vue?vue&type=script&lang=js"
export * from "./Ntfy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__